var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-select',{attrs:{"value":_vm.value,"resource":"zones","need-params":"","filterable":"","params":_vm.params},on:{"change":_vm.change}})
}
var staticRenderFns = []

export { render, staticRenderFns }